import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { styled, useTheme } from "@mui/material/styles";
import { useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "src/app/main/utilities/AgGridTable";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import FormPageHeader from "../../utilities/FormPageHeader";
import "../expense-claim/expenseClaim.css";

const expenseListURL = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimList}`;
// const ActionRenderer = (props) => {
//   return (
//     <div className="flex item-center">
//       <Button color="warning" variant="contained" sx={{ mr: 1 }}>
//         View
//       </Button>
//       <Button color="warning" variant="contained" sx={{ mr: 1 }}>
//         {" "}
//         Edit
//       </Button>
//       <Button color="warning" variant="contained">
//         {" "}
//         Print
//       </Button>
//     </div>
//   );
// };

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));
const useStyles = makeStyles((theme) => ({
  root: {
    "& li": {
      padding: "5px 10px",
      cursor: "pointer",

      "&:hover": {
        backgroundColor: "grey",
      },
    },
    // borderRadius: "20px",
    fontSize: "11px",
    textAlign: "center",
    height: "26px",
    lineHeight: "26px",
    padding: "0px 10px",
    marginTop: "6px",
  },
}));
const payGroupOptions = [
  { label: "ALL", value: "ALL" },
  { label: "Nolte FZE", value: "Nolte FZE" },
  { label: "FREE LANCE", value: "FREE LANCE" },
  { label: "IT CONSULTANT", value: "IT CONSULTANT" },
];
const SalaryRevision = (props) => {
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const classes = useStyles(props);
  const [tabValue, setTabValue] = useState("nolte");
  const navigate = useNavigate();

  const [rowData, setRowData] = useState([
    {
      code: "01",
      empName: "Gokulnath",
      department: "IT Consultant",
      subDepartment: "Development",
      designation: "Software Engineer",
    },
    {
      code: "02",
      empName: "Gokulnath",
      department: "IT Consultant",
      subDepartment: "Development",
      designation: "Software Engineer",
    },
    {
      code: "03",
      empName: "Gokulnath",
      department: "IT Consultant",
      subDepartment: "Development",
      designation: "Software Engineer",
    },
    {
      code: "04",
      empName: "Gokulnath",
      department: "IT Consultant",
      subDepartment: "Development",
      designation: "Software Engineer",
    },
  ]);
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "code",
      headerName: "Code",
      filter: "agNumberColumnFilter",
    },
    {
      field: "empName",
      headerName: "Name",
      // cellRenderer: PostingCheckboxRenderer,
    },
    {
      field: "department",
      headerName: "Department",
      // cellRenderer: InventoryCheckboxRenderer,
    },
    {
      field: "subDepartment",
      headerName: "Sub Department",
    },
    {
      field: "designation",
      headerName: "Designation",
    },
    // { headerName: "Action", cellRenderer: ActionRenderer, minWidth: 250 },
  ]);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(expenseListURL);
      // let expenseClaimList = list.data._embedded.expenses;
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);
  const onRowDoubleClicked = (params) => {
    navigate("/payroll/employee/profile");
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };
  const getContextMenuItems = (event) => {
    var result = [
      {
        name: "View",
        icon: '<span><i class="material-icons" style="font-size: 18px">visibility</i></span>',
        action: (props) => {
          navigate(
            `/salary/revision/action?val=view&id=${event.node.data.code}`
          );
        },
      },
      {
        name: "Edit",
        icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
        action: (props) => {
          navigate(
            `/salary/revision/action?val=edit&id=${event.node.data.code}`
          );
        },
      },
      {
        name: "Print",
        icon: '<span><i class="material-icons" style="font-size: 18px">print</i></span>',
        action: (props) => {
          // navigate(`/expense-claim/add?id=${event.node.data.id}`);
        },
      },

      // {
      //   name: "Delete",
      //   icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
      //   action: () => {
      //     onDelete(event);
      //   },
      // },
    ];
    return result;
  };

  const handleTabChange = (event, value) => setTabValue(value);

  return (
    <React.Fragment>
      <FormPageHeader
        componentName="List"
        pageName="Salary Revision"
        currentPage="Salary Revision"
      />

      <Stack direction={"row"} className={"items-end"} sx={{ padding: 2 }}>
        <Stack className="mr-16">
          Emp Code
          <StyledTextField
            type="text"
            className="w-[80px]"
            variant="outlined"
            name="year"
          />
        </Stack>
        <Stack className="mr-16">
          Department
          <Select
            className="w-[150px]"
            name="approval_status"
            placeholder="Status"
            options={payGroupOptions}
            styles={customStyles()}
          />
        </Stack>
        <Stack className="mr-16">
          Sub Department
          <Select
            className="w-[150px]"
            name="approval_status"
            placeholder="Status"
            options={payGroupOptions}
            styles={customStyles()}
          />
        </Stack>
        <Stack className="mr-16">
          Designation
          <Select
            className="w-[150px]"
            name="approval_status"
            placeholder="Status"
            options={payGroupOptions}
            styles={customStyles()}
          />
        </Stack>
        <Stack className="mr-16">
          Emp Name
          <Select
            className="w-[150px]"
            name="approval_status"
            placeholder="Status"
            options={payGroupOptions}
            styles={customStyles()}
          />
        </Stack>
        <Stack className="mr-16">
          Pay Group
          <Select
            className="w-[150px]"
            name="approval_status"
            placeholder="Status"
            defaultValue={payGroupOptions[0]}
            options={payGroupOptions}
            styles={customStyles()}
          />
        </Stack>
        <Button
          color="warning"
          variant="contained"
          startIcon={
            <FuseSvgIcon size={18}>heroicons-outline:search</FuseSvgIcon>
          }
          sx={{ mr: 1 }}
        />
      </Stack>

      {/* <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="secondary"
          sx={{ color: "yellow" }}
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}          
        >
          <Tab label="FTP (2)" value={"nolte"} />
          <Tab label="FTFL(3)" value={"free-lance"} />
          <Tab label="PTC (21)" value={"it-consultant"} />
          <Tab label="PTH (21)" value={"it-consultant"} />
        </Tabs> */}

      <AgGridTable
        hideCheckbox={true}
        columnDefs={columnDefs}
        onGridReady={onGridReady}
        gridRef={gridRef}
        rowData={rowData}
        rowGroupPanelShow="never"
        getContextMenuItems={getContextMenuItems}
        editable={false}
        pagination={false}
        onSelectionChanged={onSelectionChanged}
      />
    </React.Fragment>
  );
};

export default SalaryRevision;
